module.exports = __webpack_public_path__ + "static/media/MH.34d4111d.png";